// extracted by mini-css-extract-plugin
export default {"contactTitle":"_1blDQGy6tSX19kXSd4fTcf"};